import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _EVOLUTION_PRODUCTS;
import { ArenadataDbSVG, ArtifactRegistrySVG, BareMetalSVG, ContainerAppsSVG, ElasticCloudServerWithGpuSVG, EvolutionComputeSVG, ManagedKubernetesSVG, ManagedPostgreSqlSVG, MlInferenceSVG, PublicIpSVG, S3StorageSVG, SnatSVG } from '@sbercloud/uikit-product-icons';
import { PLATFORM } from '../../../constants';
import { EVOLUTION_PRODUCT } from './constants';
import { EVOLUTION_ARENADATA_DB_FORM_CONFIG, EVOLUTION_ARTIFACT_REGISTRY, EVOLUTION_BARE_METAL_FORM_CONFIG, EVOLUTION_CLOUD_SERVER_FORM_CONFIG, EVOLUTION_CLOUD_SERVER_FREE_TIER_FORM_CONFIG, EVOLUTION_CLOUD_SERVER_GPU_FORM_CONFIG, EVOLUTION_CONTAINER_APPS_CONFIG, EVOLUTION_CONTAINER_APPS_FREE_TIER_CONFIG, EVOLUTION_KUBERNETES_FORM_CONFIG, EVOLUTION_ML_INFERENCE_FORM_CONFIG, EVOLUTION_POSTGRE_SQL_FORM_CONFIG, EVOLUTION_PUBLIC_IP_FORM_CONFIG, EVOLUTION_SNAT_GATEWAY_FORM_CONFIG, EVOLUTION_STORAGE_S3_FORM_CONFIG, EVOLUTION_STORAGE_S3_FREE_TIER_FORM_CONFIG } from './product-config';
export var EVOLUTION_PRODUCTS = (_EVOLUTION_PRODUCTS = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_EVOLUTION_PRODUCTS, EVOLUTION_PRODUCT.EvolutionCloudServer, {
  id: EVOLUTION_PRODUCT.EvolutionCloudServer,
  platform: PLATFORM.Evolution,
  label: 'Evolution Compute',
  caption: 'Виртуальные машины для развертывания сервисов и приложений',
  icon: EvolutionComputeSVG,
  dataTestId: 'evolutionCloudServer',
  formConfig: EVOLUTION_CLOUD_SERVER_FORM_CONFIG,
  enableChangeProductQuantity: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionCloudServerFreeTier, {
  id: EVOLUTION_PRODUCT.EvolutionCloudServerFreeTier,
  platform: PLATFORM.Evolution,
  label: 'Evolution Compute Free Tier',
  caption: 'Бесплатная виртуальная машина в заданной конфигурации',
  formConfig: EVOLUTION_CLOUD_SERVER_FREE_TIER_FORM_CONFIG,
  icon: EvolutionComputeSVG,
  dataTestId: 'evolutionCloudServerFreeTier',
  freeTier: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionKubernetes, {
  id: EVOLUTION_PRODUCT.EvolutionKubernetes,
  platform: PLATFORM.Evolution,
  label: 'Evolution Managed Kubernetes',
  caption: 'Управление контейнерными приложениями в кластере Kubernetes',
  formConfig: EVOLUTION_KUBERNETES_FORM_CONFIG,
  icon: ManagedKubernetesSVG,
  dataTestId: 'evolutionKubernetes',
  enableChangeProductQuantity: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionStorageS3FreeTier, {
  id: EVOLUTION_PRODUCT.EvolutionStorageS3FreeTier,
  platform: PLATFORM.Evolution,
  label: 'Evolution Object Storage Free Tier',
  caption: 'Ежемесячный объем бесплатных ресурсов в хранилище',
  formConfig: EVOLUTION_STORAGE_S3_FREE_TIER_FORM_CONFIG,
  icon: S3StorageSVG,
  dataTestId: 'evolutionStorageS3FreeTier',
  freeTier: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionStorageS3, {
  id: EVOLUTION_PRODUCT.EvolutionStorageS3,
  platform: PLATFORM.Evolution,
  label: 'Evolution Object Storage',
  caption: 'Масштабируемое хранилище S3 для всех типов данных',
  icon: S3StorageSVG,
  formConfig: EVOLUTION_STORAGE_S3_FORM_CONFIG,
  dataTestId: 'evolutionStorageS3',
  enableChangeProductQuantity: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionManagedPostgreSQL, {
  id: EVOLUTION_PRODUCT.EvolutionManagedPostgreSQL,
  platform: PLATFORM.Evolution,
  label: 'Evolution Managed PostgreSQL®',
  caption: 'Управляемые базы данных PostgreSQL®',
  icon: ManagedPostgreSqlSVG,
  formConfig: EVOLUTION_POSTGRE_SQL_FORM_CONFIG,
  dataTestId: 'evolutionPostgreSql',
  enableChangeProductQuantity: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionBareMetal, {
  id: EVOLUTION_PRODUCT.EvolutionBareMetal,
  platform: PLATFORM.Evolution,
  label: 'Evolution Bare Metal',
  caption: 'Сервис аренды физических серверов с доступом и управлением только для вас',
  icon: BareMetalSVG,
  formConfig: EVOLUTION_BARE_METAL_FORM_CONFIG,
  dataTestId: EVOLUTION_PRODUCT.EvolutionBareMetal,
  enableChangeProductQuantity: false,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionCloudServerGpu, {
  id: EVOLUTION_PRODUCT.EvolutionCloudServerGpu,
  platform: PLATFORM.Evolution,
  label: 'Вычислительные мощности с GPU',
  caption: 'Аренда виртуальных машин, серверов и ML-сервисов с графическими ускорителями',
  icon: ElasticCloudServerWithGpuSVG,
  formConfig: EVOLUTION_CLOUD_SERVER_GPU_FORM_CONFIG,
  dataTestId: EVOLUTION_PRODUCT.EvolutionCloudServerGpu,
  enableChangeProductQuantity: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionContainerApps, {
  id: EVOLUTION_PRODUCT.EvolutionContainerApps,
  platform: PLATFORM.Evolution,
  label: 'Evolution Container Apps',
  caption: 'Сервис для запуска контейнерных приложений в облаке',
  icon: ContainerAppsSVG,
  formConfig: EVOLUTION_CONTAINER_APPS_CONFIG,
  dataTestId: EVOLUTION_PRODUCT.EvolutionContainerApps,
  enableChangeProductQuantity: true,
  productQuantityValues: {
    max: 5
  },
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionContainerAppsFreeTier, {
  id: EVOLUTION_PRODUCT.EvolutionContainerAppsFreeTier,
  platform: PLATFORM.Evolution,
  label: 'Evolution Container Apps Free Tier',
  caption: 'Сервис для запуска контейнерных приложений в облаке',
  icon: ContainerAppsSVG,
  formConfig: EVOLUTION_CONTAINER_APPS_FREE_TIER_CONFIG,
  dataTestId: EVOLUTION_PRODUCT.EvolutionContainerAppsFreeTier,
  enableChangeProductQuantity: true,
  freeTier: true,
  disabledProductQuantity: true,
  enableConnectToConsole: true
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_EVOLUTION_PRODUCTS, EVOLUTION_PRODUCT.EvolutionArenadataDb, {
  id: EVOLUTION_PRODUCT.EvolutionArenadataDb,
  platform: PLATFORM.Evolution,
  label: 'Evolution Managed Arenadata DB',
  caption: 'Управляемые инстансы базы данных Greenplum',
  icon: ArenadataDbSVG,
  formConfig: EVOLUTION_ARENADATA_DB_FORM_CONFIG,
  dataTestId: EVOLUTION_PRODUCT.EvolutionArenadataDb,
  enableChangeProductQuantity: true,
  enableConnectToConsole: false,
  productQuantityValues: {
    max: 3
  }
}), EVOLUTION_PRODUCT.EvolutionMlInference, {
  id: EVOLUTION_PRODUCT.EvolutionMlInference,
  platform: PLATFORM.Evolution,
  label: 'Evolution ML Inference',
  caption: 'Cервис для запуска и развертывания моделей машинного (ML) и глубокого обучения (DL) из библиотеки Hugging Face на облачных GPU',
  icon: MlInferenceSVG,
  formConfig: EVOLUTION_ML_INFERENCE_FORM_CONFIG,
  dataTestId: EVOLUTION_PRODUCT.EvolutionMlInference,
  enableChangeProductQuantity: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionSnatGateway, {
  id: EVOLUTION_PRODUCT.EvolutionSnatGateway,
  platform: PLATFORM.Evolution,
  label: 'Evolution SNAT Gateway',
  caption: 'Доступ виртуальных машин и серверов к внешним ресурсам',
  icon: SnatSVG,
  formConfig: EVOLUTION_SNAT_GATEWAY_FORM_CONFIG,
  dataTestId: EVOLUTION_PRODUCT.EvolutionSnatGateway,
  enableChangeProductQuantity: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionPublicIp, {
  id: EVOLUTION_PRODUCT.EvolutionPublicIp,
  platform: PLATFORM.Evolution,
  label: 'Evolution Public IP',
  caption: 'Управление публичными IP-адресами для облачных ресурсов',
  icon: PublicIpSVG,
  formConfig: EVOLUTION_PUBLIC_IP_FORM_CONFIG,
  dataTestId: EVOLUTION_PRODUCT.EvolutionPublicIp,
  enableChangeProductQuantity: true,
  enableConnectToConsole: true
}), EVOLUTION_PRODUCT.EvolutionArtifactRegistry, {
  id: EVOLUTION_PRODUCT.EvolutionArtifactRegistry,
  platform: PLATFORM.Evolution,
  label: 'Evolution Artifact Registry',
  caption: 'Реестр для хранения OCI-артефактов',
  icon: ArtifactRegistrySVG,
  formConfig: EVOLUTION_ARTIFACT_REGISTRY,
  dataTestId: EVOLUTION_PRODUCT.EvolutionArtifactRegistry,
  enableChangeProductQuantity: true,
  enableConnectToConsole: false
}));